// extracted by mini-css-extract-plugin
export default {"data-room__text-box":"style_data-room__text-box__u6DoP","data-room__container":"style_data-room__container__iFBW8"};